import { joiResolver } from '@hookform/resolvers/joi';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as Joi from 'joi';
import { useState } from 'react';
import { MutationStatus } from 'react-query';
import { useGetRegistrationDocument } from '../../../api-refactored/candidate/useGetRegistrantionReportDocument';
import { FileUploadState } from '../../../models/File';
import { usePostNonNationalReport } from '../../../api-refactored/candidate/usePostGenerateReport';

interface EditDeleteReturn {
  /**
   * Perform submit action, either to call block call or unblock call, depends on the account status
   */
  submitGenerate: (submitData: any) => void;
  /**
   * Form to send edit & delete
   */
  form: UseFormReturn<Record<string, any>>;
  /**
   * React query mutation object
   */
  generateReportMutation: any;

  getDocumentUploadStatus: any;

  fileDownloadStatus: FileUploadState;
  onDialogClose: () => void;
  dialogState: boolean;
  process: MutationStatus;
}

/**
 * A hook to handle search functionality
 * @returns
 */
export const useNonNationalReport = (): EditDeleteReturn => {
  const [fileUUID, setFileUUID] = useState('');
  const [process, setProcess] = useState<MutationStatus>('idle');
  const [fileDownloadStatus, setFileDownloadStatus] = useState<FileUploadState>(
    FileUploadState.IDLE
  );
  const [dialogState, setDialogState] = useState<boolean>(false);

  const form = useForm({
    mode: 'onSubmit',
    resolver: joiResolver(schema),
  });

  const getDocumentUploadStatus = useGetRegistrationDocument({
    fileKey: fileUUID || '',
    enabled: !!fileUUID && process === 'loading',
    refetchInterval: 5000,
    onSuccess: (res) => {
      setDialogState(true);
      setFileDownloadStatus(res.fileStatus);

      if (res.fileStatus === FileUploadState.FAILED || res.fileStatus === FileUploadState.TIMEOUT) {
        setProcess('error');
        setFileUUID('');
      }

      if (res.fileStatus === FileUploadState.UPLOADING) {
        setProcess('loading');
      }

      if (res.fileStatus === FileUploadState.SUCCESS) {
        setProcess('success');

        const newWindow = window.open(res.url, '_blank', 'noopener,noreferrer');
        if (newWindow) {
          newWindow.opener = null;
        }
        setFileUUID('');
        setDialogState(false);
      }
    },
    onError: () => {
      setDialogState(false);
    },
  });

  const generateReportMutation = usePostNonNationalReport({
    onSuccess: (res) => {
      setFileUUID(res.uuid);
    },
    onError: (err) => null,
  });

  const submitGenerate = (submitData: any) => {
    setProcess('loading');
    generateReportMutation.mutate({
      examLevel: submitData?.examLevel || [],
      academicLevel: submitData?.academicLevel || [],
    });
  };

  const onDialogClose = () => {
    setDialogState(false);
  };

  return {
    form,
    submitGenerate,
    generateReportMutation,
    getDocumentUploadStatus,
    fileDownloadStatus,
    onDialogClose,
    dialogState,
    process,
  };
};

const schema = Joi.object({
  examLevel: Joi.array()
    .items(Joi.object({ code: Joi.string(), description: Joi.string(), flag: Joi.boolean() }))
    .has(Joi.object({ code: Joi.string(), description: Joi.string(), flag: Joi.boolean() }))
    .messages({
      'array.hasUnknown': 'Exam Level cannot be empty',
    }),
  academicLevel: Joi.any(),
});
